// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from "vue";
import App from "./App";
//vuex
import store from "./store";
import router from "./router";
import Router from "vue-router";
Vue.prototype.store = store;

import ElementUI from "element-ui";
import "element-ui/lib/theme-chalk/index.css";

import VueI18n from "vue-i18n";

//公共js方法
import common from "./assets/js/common.js";

Vue.prototype.common = common;

// ajax方法
import ajax from "./assets/js/ajax.js";
import Token from "./assets/js/token";

Vue.prototype.$ajax = ajax;
Vue.prototype.$Token = Token;

import "@/assets/css/init.css";
// import "@/assets/css/cssPublic.css";
import "../theme/index.css";

import jsCookie from "js-cookie";

Vue.prototype.$cookie = jsCookie;

Vue.use(Router);

Vue.use(VueI18n); // 通过插件的形式挂载

Vue.use(ElementUI);

Vue.config.productionTip = false;
/* eslint-disable no-new */

// 高德地图配置
// import VueAMap from "vue-amap"; // 引入插件
// Vue.use(VueAMap); // 使用插件
// VueAMap.initAMapApiLoader({ // 初始化插件
//     key: "b53f767aeeb00d5a725c8bfab784f651", // 高德key，自己官网申请即可，这里是我申请的
//     plugin: ["AMap.Geocoder"],  // 插件集合，这里只有一个定位功能，所以就只放一个AMap.Geocoder
//     uiVersion: "1.0.11", // 不加会报错，加上吧
//     v: "2.0", // 不加也不会影响，顺手加上吧
// });

const i18n = new VueI18n({
  locale: "zh-CN", // 语言标识
  //this.$i18n.locale // 通过切换locale的值来实现语言切换
  messages: {
    "zh-CN": require("./common/lang/zh"), // 中文语言包
    "en-US": require("./common/lang/en") // 英文语言包
  }
});

window.v = new Vue({
  el: "#app",
  i18n, // 不要忘记这里也要配置
  router,
  store,
  components: {App},
  template: "<App/>"
});



// WEBPACK FOOTER //
// ./src/main.js